import type { RouteObject } from 'react-router';
import { PackagePolicyPage } from './pages/package-policy-page';
import { PackagePolicyDetailPage } from './pages/package-policy-detail-page';
import { PackageBlocklistPage } from './pages/package-blocklist-page';
import { PackageAllowlistPage } from './pages/package-allowlist-page';
import { VulnerabilitySearchPage } from './pages/vulnerability-search-page';
import { PackageDetailPage } from './pages/package-detail-page';

export const packageSecurityRoutes: RouteObject[] = [
  { path: 'package-security', element: <PackagePolicyPage /> },
  { path: 'package-security/policies/:ecosystem', element: <PackagePolicyDetailPage /> },
  { path: 'package-security/blocklist', element: <PackageBlocklistPage /> },
  { path: 'package-security/allowlist', element: <PackageAllowlistPage /> },
  { path: 'package-security/vulnerabilities', element: <VulnerabilitySearchPage /> },
  { path: 'package-security/packages/:ecosystem/:packageName', element: <PackageDetailPage /> },
];
